import { NavContentBlueprint } from '@backstage/plugin-app-react';

import { Sidebar } from './Sidebar';

export const SidebarExtension = NavContentBlueprint.make({
  params: {
    component: Sidebar,
  },
});
